import { Box, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { LucideBell } from "lucide-react";
import { type Dispatch, type SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import { useNotificationQuery } from "../../../queries";
import { DROPDOWN, type Dropdown } from "../Header.consts";

export function NotificationsIcon({
  showNotifications,
  setAnchorElNotify, // not need for mobile
  setDropdown
}: {
  showNotifications: boolean
  setAnchorElNotify?: Dispatch<SetStateAction<HTMLElement | null>>
  setDropdown: Dispatch<SetStateAction<Dropdown | null>>
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { data: userNotifications } = useNotificationQuery({});

  const unreadNotifications = userNotifications?.filter((notification) => notification.isRead === "N") ?? [];

  return (
    <Button
      title= { t("notify_text") }
      disableRipple
      color={ "inherit" }
      aria-describedby={ showNotifications ? "simple-popover" : undefined }
      onClick={ (clickEvent) => {
        showNotifications && setDropdown(null);
        showNotifications || setDropdown(DROPDOWN.NOTIFICATIONS);
        setAnchorElNotify && setAnchorElNotify(clickEvent.currentTarget);
      } }
      sx={ {
        "&:hover": {
          background: "transparent"
        },
        color: theme.customColors.headerIcon,
        height: "100%",
        minWidth:"unset",
        paddingX: "5px",
        paddingY: "0",
        position:"relative",
        zIndex: theme.zIndex.fab
      } }
    >
      <>
        <LucideBell
          size={ 24 }
        />

        { unreadNotifications.length ? (
          <Box sx={ {
            alignItems: "center",
            backgroundColor: theme.customColors.backgroundPrimaryCta,
            borderRadius: "999px",
            display: "flex",
            height: "20px",
            justifyContent: "center",
            position: "absolute",
            right: 0,
            top: 0,
            width: "20px"
          } }>
            <Typography style={ { fontSize: "10px" } } color={ theme.customColors.textPrimaryCta }>
              { unreadNotifications.length }
            </Typography>
          </Box>
        ) : <div/> }
      </>
    </Button>
  );
}
